import { useQuery } from '@apollo/client';
import { useToast } from '@synoptic/ui-kit/toast/toast-provider.js';
import { gql } from '@/__generated__/index.ts';
import { User } from '@/__generated__/schema-types.ts';

const HighlightedAuthorsQuery = gql(`
  query highlightedAuthors {
    highlightedAuthors {
      ...UserCardFragment
      id
      following
      bio
      streams {
        items {
          ...StreamCardFragment
        }
      }
    }
  }
`);

export const useHighlightedAuthors = () => {
  const toast = useToast();
  const { data, loading } = useQuery(HighlightedAuthorsQuery, {
    onError: () => {
      toast.error({
        title: 'Failed to fetch highlighted authors',
      });
    },
  });

  return {
    authors: data?.highlightedAuthors as User[],
    areAuthorsEmpty: data?.highlightedAuthors?.length === 0,
    loading: loading,
  };
};
